import { getTgWebApp } from "@/helpers/tgWebApp"

export enum APP_RETURN_SIGNAL {
  HIDDEN = "HIDDEN",
  VISIBLE = "VISIBLE",
  DEACTIVATED = "DEACTIVATED",
  ACTIVATED = "ACTIVATED"
}

export interface IAppReturnState {
  away: boolean
}

const AWAY_SIGNALS = new Set([
  APP_RETURN_SIGNAL.HIDDEN,
  APP_RETURN_SIGNAL.DEACTIVATED
])

/** One background spell is one return, even when the page and Telegram both report it. */
export const nextAppReturnState = (
  state: IAppReturnState,
  signal: APP_RETURN_SIGNAL
): { state: IAppReturnState; isReturn: boolean } => {
  if (AWAY_SIGNALS.has(signal)) {
    return { state: { away: true }, isReturn: false }
  }

  return { state: { away: false }, isReturn: state.away }
}

const listeners = new Set<() => void>()
let detectorState: IAppReturnState = { away: false }

const receiveSignal = (signal: APP_RETURN_SIGNAL) => {
  const next = nextAppReturnState(detectorState, signal)
  detectorState = next.state

  if (next.isReturn) {
    listeners.forEach((listener) => listener())
  }
}

const onVisibilityChange = () =>
  receiveSignal(
    document.visibilityState === "hidden"
      ? APP_RETURN_SIGNAL.HIDDEN
      : APP_RETURN_SIGNAL.VISIBLE
  )
const onDeactivated = () => receiveSignal(APP_RETURN_SIGNAL.DEACTIVATED)
const onActivated = () => receiveSignal(APP_RETURN_SIGNAL.ACTIVATED)

const attachSignals = () => {
  const telegram = getTgWebApp()
  document.addEventListener("visibilitychange", onVisibilityChange)
  telegram?.onEvent("deactivated", onDeactivated)
  telegram?.onEvent("activated", onActivated)
}

const detachSignals = () => {
  const telegram = getTgWebApp()
  document.removeEventListener("visibilitychange", onVisibilityChange)
  telegram?.offEvent("deactivated", onDeactivated)
  telegram?.offEvent("activated", onActivated)
  detectorState = { away: false }
}

export const subscribeAppReturn = (listener: () => void): (() => void) => {
  if (listeners.size === 0) {
    attachSignals()
  }
  listeners.add(listener)

  return () => {
    if (!listeners.delete(listener)) {
      return
    }
    if (listeners.size === 0) {
      detachSignals()
    }
  }
}
